import React from "react";
import { getStatusColor } from "../core/btw-status-colors";

const SIZES = {
  sm: "px-1.5 py-px text-[10px]",
  md: "px-2 py-0.5 text-[11px]",
  lg: "px-2.5 py-1 text-xs",
};

const BtwStatusPill = ({ status, size = "md", className = "" }) => {
  const sizes = SIZES[size] ?? SIZES.md;
  if (!status) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded bg-[#091E420F] font-bold uppercase tracking-wide text-ink-subtle ${sizes} ${className}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-ink-disabled" />
        Geen status
      </span>
    );
  }
  const colors = getStatusColor(status.color);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-bold uppercase tracking-wide ${colors.pill} ${sizes} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${colors.dot}`} />
      {status.name}
    </span>
  );
};

export default BtwStatusPill;
